/**
 * Buckets a session into one of the five categories shown in the my-profile
 * weekly session grouping. gizmo/aero sessions have no `sport` field at all
 * (LeGizmo's CdA testing is cycling-only) so they're always Cycling; Garmin
 * sessions map from the raw FIT sport string (functions/src/garminMetrics.ts's
 * SPORT_NAMES has the full device-side vocabulary -- only the subset
 * relevant to bucketing is mapped here, everything else falls to Other).
 */
export type SportCategory = 'Cycling' | 'Running' | 'Swimming' | 'Strength' | 'Other'

const RUNNING_SPORTS = new Set(['running'])
const SWIMMING_SPORTS = new Set(['swimming'])
const CYCLING_SPORTS = new Set(['cycling', 'e_biking'])
const STRENGTH_SPORTS = new Set(['fitness_equipment', 'training', 'tactical'])

export function categorizeSport(source: 'gizmo' | 'garmin' | 'manual', sport: string | null): SportCategory {
  if (source === 'gizmo') return 'Cycling'
  if (!sport) return 'Other'
  if (CYCLING_SPORTS.has(sport)) return 'Cycling'
  if (RUNNING_SPORTS.has(sport)) return 'Running'
  if (SWIMMING_SPORTS.has(sport)) return 'Swimming'
  if (STRENGTH_SPORTS.has(sport)) return 'Strength'
  return 'Other'
}
